import React, { FunctionComponent } from 'react'

import { ProposalStatus } from '../../../domain'
import { useProposal } from '../proposal/ProposalProvider'
import { RenewalQuotePage } from './RenewalQuotePage'
import { RenewalReferralPage } from './RenewalReferralPage'

export const RenewalSummaryPage: FunctionComponent = () => {
  const { proposal } = useProposal()

  switch (proposal.status) {
    case ProposalStatus.POLICY:
    case ProposalStatus.QUOTE:
      return <RenewalQuotePage />
    case ProposalStatus.REFERRAL:
      return <RenewalReferralPage />
    case ProposalStatus.QUOTE_EXPIRED:
    case ProposalStatus.INSUFFICIENT_ACCURACY:
      throw new Error(`Renewal unsupported in status ${proposal.status}`)
  }
}
